import { render, staticRenderFns } from "./conventionalCar.vue?vue&type=template&id=5b5c4d21&scoped=true&"
import script from "./conventionalCar.vue?vue&type=script&lang=js&"
export * from "./conventionalCar.vue?vue&type=script&lang=js&"
import style0 from "./conventionalCar.vue?vue&type=style&index=0&id=5b5c4d21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c4d21",
  null
  
)

export default component.exports